import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap'

const FieldInputArea = ({ input, type, name, label, placeholder, meta: { touched, error, warning }, focus, handleChange, isDisabled }) => {
    return (
        <>
            <Form.Label htmlFor={name}>{label}</Form.Label>

            {

                !!handleChange ?

                    <Form.Control as="textarea" rows="3"
                        autoFocus={focus}
                        {...input}
                        type={type}
                        name={name}
                        placeholder={placeholder}
                        isInvalid={touched && (error || warning)}
                        onBlur={handleChange}
                        disabled={isDisabled}
                    /> :
                    <Form.Control as="textarea" rows="3"
                        autoFocus={focus}
                        {...input}
                        type={type}
                        name={name}
                        placeholder={placeholder}
                        isInvalid={touched && (error || warning)}
                        disabled={isDisabled}
                    />

            }

            {/* {touched && ((error && <p className="text-danger">{error}</p>) || (warning && <p className="text-danger">{warning}</p>))} */}
            <Form.Control.Feedback type="invalid">
                {error}
            </Form.Control.Feedback>
        </>
    );
};



FieldInputArea.propTypes = {
    input: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    meta: PropTypes.object.isRequired,
    focus: PropTypes.bool,
    handleChange: PropTypes.func,
    isDisabled: PropTypes.bool
};



export default FieldInputArea;
